import React from "react";

import { IoBulbOutline } from "react-icons/io5";

/**
 * Tooltip component that displays a text with an optional icon.
 *
 * @param {Object} props - The component props.
 * @param {string} props.text - The text to display inside the tooltip.
 * @param {string} [props.className] - Additional class names for styling the tooltip.
 * @param {boolean} [props.icon=true] - Flag to determine if the icon should be displayed.
 * @returns {JSX.Element} The rendered Tooltip component.
 */
const Tooltip = ({ text, secondaryText, className, icon = true }) => {
  return (
    <div className={`flex flex-col whitespace-nowrap ${className}`}>
      <div className="flex flex-row">
        {icon ? <IoBulbOutline size="12" /> : null}
        <p className={secondaryText ? "my-auto" : "m-auto"}>{text}</p>
      </div>
      {secondaryText && (
        <div>
          <p className="my-auto font-normal">{secondaryText}</p>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
